module.exports = __webpack_public_path__ + "img/judge-3.a4b5fcb1.png";